import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";

const useUpdateBookGeoRestrictions = (bookId) => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const updateGeoRestrictions = async (data) => {
		const instance = await InitApi({ accessToken, userIp });
		const response = await instance.put(`/admin/books/${bookId}/geo-restrictions`, data);
		return response.data;
	};

	return useMutation(updateGeoRestrictions, {
		onSuccess: async ({ data: body }) => {
			// Invalidate related queries
			await queryClient.invalidateQueries(["book_geo_restrictions", bookId]);
			await queryClient.invalidateQueries(["book", bookId]);
			await queryClient.invalidateQueries("books");

			toast.success("Geo-restriction settings updated successfully!");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useUpdateBookGeoRestrictions;
